<section>
  <p>Powered by </p>
  <img src="/assets/media/images/logo/logo.png" alt="">
</section>
